import axios from "axios";

// TODO Should be fetched form the env file
const baseURL = "";//configure baseURL 

export const instance = axios.create({
  baseURL,
  timeout: 100000,
});

instance.interceptors.response.use(

  (response:any) => response,
  (error:any) => Promise.reject(error)
);

export default instance;
